module.exports = __webpack_public_path__ + "df73d6f41b075fd537a103ec8acdb27b.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/festival03.jpg
// module id = 653
// module chunks = 0